var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Main',[_c('section',{ref:"reportcontainer",staticClass:"resp-pbicontainer",attrs:{"id":"report-container"}}),_c('section',{staticClass:"error-container m-5"})])
}
var staticRenderFns = []

export { render, staticRenderFns }